export function restoreURL(url) {
	if (!url) {
		return '';
	}
	if (url.indexOf('http') >= 0 || url.indexOf('https') >= 0) {
		return url;
	}
	const barChar = url.startsWith("/")? "": "/";
	const fullUrl = window.location.protocol + "//" + window.location.host + barChar + url;
	return fullUrl;
}
